import { InjectionToken } from '@angular/core';

export const API_URL = new InjectionToken<string>('API_URL');

export const SSD_API_URL = new InjectionToken<string>('SSD_API_URL');

export const ZABBIX_API_URL = new InjectionToken<string>('ZABBIX_API_URL');

export const ENV_STAGE = new InjectionToken<string>('ENV_STAGE');
